import createSuccessPromiseThunk from "~/rx/lib/createSuccessPromiseThunk";
import createModelApi from "~/backend/modelApi";
import {getItemId, getModelName, getParentId} from "~/stateGetter";
import identify from "~/identify";
import {modify} from "mythil/object";
import {pushClose, smartGoto} from "~/actions/navigation_actions";
import invalidateLoadedModels from "~/reducers/helpers/invalidateLoadedModels";
import preloadClose from "~/rx/lib/preloadClose";
import authenticatedRequest from "~/backend/authenticatedRequest";

const itemDelete = createSuccessPromiseThunk({
    func: async ({modelId, getState, dispatch, getConfig}) => {
        let state = getState(),
            modelApi = createModelApi(
                getConfig().baseUrl,
                getModelName(state, modelId),
                (foo) => authenticatedRequest(foo, dispatch)
            ),
            itemId = getItemId(state, modelId);

        let deleteResult = await modelApi.deleteItem(itemId);

        if(!deleteResult.success) { return deleteResult; }
        if(deleteResult.redirect) {
            dispatch(smartGoto(deleteResult.redirect, {noConfirm: true}, { replace: true}));
            return deleteResult;
        }

        if (getParentId(state, modelId)) await preloadClose(dispatch, state, modelId);
        dispatch(pushClose({noConfirm: true, goBack: !!getParentId(state, modelId), forceChangeRootModel: true }));

        return deleteResult;
    },
    name: 'deleteItem',
});

let execute = itemDelete.execute;
itemDelete.execute = (modelId) => execute({modelId}, {modelId});

let reduce = itemDelete.reduce;
itemDelete.reduce = (model, action, state) => {
    model = modify(model, 'deleteResult', (deleteResult) => {
        switch(action.type) {
            case itemDelete.types.SUCCESS:
                return {
                    ...deleteResult,
                    status: identify.STATUS_SUCCESS,
                    finished_at: Date.now(),
                    value: {
                        messages: action.value.messages
                    }
                };
            default:
                return reduce(deleteResult, action);
        }
    });

    switch(action.type) {
        case itemDelete.types.SUCCESS:
            return modify(model, 'item.id', null);
    }

    return model;
};

itemDelete.reduceState = (state, action) => {
    switch(action.type) {
        case itemDelete.types.SUCCESS:
            return invalidateLoadedModels(state);
        default:
            return state;
    }
};

const reduceDeleteItem = itemDelete.reduce,
    DELETE_ITEM_TYPES = itemDelete.types,
    deleteItem = itemDelete.execute,
    reduceItemDeleteState = itemDelete.reduceState;

export {
    reduceDeleteItem,
    reduceItemDeleteState,
    DELETE_ITEM_TYPES,
    deleteItem,
}